import type { CSSProperties } from 'react';

export interface SkeletonProps {
  className?: string;
  style?: CSSProperties;
}

/**
 * Low-level pulsing block. Fully sized/shaped by the consumer via
 * `className` / `style`; only contributes the shimmer + fill colour.
 */
export function Skeleton({ className = '', style }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={`animate-pulse bg-white/15 rounded-[8px] ${className}`.trim()}
      {...(style ? { style } : {})}
    />
  );
}
